import type { Question } from '@webapp/common/resources/entities/question';

export interface QuestionsState {
    items: Array<Question>;
    expanded: boolean;
    confirmRemove: boolean;
    fetch: boolean;
}

export const questionsInitial: QuestionsState = {
    items: [],
    expanded: true,
    confirmRemove: true,
    fetch: false,
};
